import {
  AppBar,
  Collapse,
  Drawer,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import React, { useState } from "react";
import { all_Data } from "../../mockdata/MockData";

export default function MobileNavigation() {
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openCollapse, setOpenCollapse] = useState({});

  const handleToggleDrawer = () => {
    setDrawerOpen((prev) => !prev);
  };

  const handleCollapse = (navLink) => {
    setOpenCollapse((prevState) => ({
      ...prevState,
      [navLink]: !prevState[navLink],
    }));
  };

  return (
    <>
      {/* AppBar */}
      <AppBar
        position="static"
        elevation={0}
        sx={{ backgroundColor: "#100c08", borderBottom: "1px solid var(--border)" }}
      >
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            onClick={handleToggleDrawer}
            sx={{ mr: 2, color: "var(--primary)" }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{ flexGrow: 1, color: "var(--text-main)" }}
          >
            Admin
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Drawer Sidebar */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={handleToggleDrawer}
        className="!w-[220px]"
        PaperProps={{
          sx: {
            width: 220,
            backgroundColor: "#100c08",
            borderRight: "1px solid var(--border)",
          },
        }}
      >
        <List className="!p-4">
          {all_Data?.map((nav) => (
            <React.Fragment key={nav.id}>
              <ListItemButton
                onClick={() => {
                  if (nav.subcomponent?.length > 0) {
                    handleCollapse(nav.navLink);
                  } else {
                    navigate(nav.navLink);
                    setDrawerOpen(false);
                  }
                }}
                className={classNames("!rounded-lg !p-2")}
                sx={{
                  color: window.location.pathname === nav.navLink ? "var(--primary)" : "var(--text-main)",
                  "&:hover": { backgroundColor: "var(--input-bg)" },
                }}
              >
                <ListItemText primary={nav.navItem} />
                {nav.subcomponent?.length > 0 &&
                  (openCollapse[nav.navLink] ? <ExpandLess /> : <ExpandMore />)}
              </ListItemButton>
              {/* Submenu */}
              <Collapse in={openCollapse[nav.navLink]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {nav.subcomponent?.map((subNav) => (
                    <ListItemButton
                      key={subNav.id}
                      onClick={() => {
                        navigate(subNav.navLink);
                        setDrawerOpen(false);
                      }}
                      className={classNames("!rounded-lg")}
                      sx={{
                        pl: 4,
                        color: window.location.pathname === subNav.navLink ? "var(--primary)" : "var(--text-muted)",
                        "&:hover": { backgroundColor: "var(--input-bg)" },
                      }}
                    >
                      <ListItemText primary={subNav.navItem} />
                    </ListItemButton>
                  ))}
                </List>
              </Collapse>
            </React.Fragment>
          ))}

          {/* Logout Button */}
          <ListItemButton
            onClick={() => {
              localStorage.clear();
              sessionStorage.clear();
              navigate("/");
            }}
            sx={{ color: "#d44", "&:hover": { backgroundColor: "rgba(200,60,60,0.1)" } }}
          >
            <ListItemText primary={"Logout"} />
          </ListItemButton>
        </List>
      </Drawer>
    </>
  );
}
